import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme: MuiTheme) => ({
  section: {
    padding: 0,
    borderTop: "1px solid #d7d7d7",
    boxShadow: "none",
    "&:nth-child(even)": {
      background: "#f6f6f6"
    },
    "& .MuiCollapse-root": {
      paddingBottom: 12,
      [theme.breakpoints.up("md")]: {
        paddingBottom: 0
      },
      "&.MuiCollapse-hidden": {
        padding: 0
      },
      [theme.breakpoints.up("md")]: {
        paddingBottom: 24
      }
    },
    [theme.breakpoints.up("md")]: {
      "&:first-child": {
        borderTop: "none"
      },
      paddingLeft: 24
    }
  },
  sectionHeader: {
    height: 64,
    "&$sectionHeaderExpanded": {
      borderBottomColor: "transparent"
    },
    [theme.breakpoints.up("md")]: {
      height: 55,
      paddingTop: 10,
      paddingLeft: 0
    }
  },
  sectionHeaderExpanded: {},
  sectionHeaderContent: {
    alignItems: "center",
    fontSize: 16,
    [theme.breakpoints.up("md")]: {
      height: 45
    }
  },
  fieldsGroup: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    "& .MuiFormHelperText-root": {
      fontSize: 11,
      marginLeft: 0
    },
    [theme.breakpoints.up("md")]: {
      paddingLeft: 0,
      paddingRight: 20
    }
  }
}));
